import React from 'react';
var CornerTick = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 100 100" },
        React.createElement("polygon", { fill: fill, points: "47.07 2.881 30.519 9.734 30.519 126.028 47.07 132.881 105.243 74.734 105.243 61.028", transform: "rotate(45 67.881 67.881)" })));
};
export default CornerTick;
